export default {
    videoSpeaker: {
        index01: '我是简体',
    },
    // 公共
    common: {
        cancel: '取消',
        del: '确定',
    },
    //登录页面
    login: {
        welcomeUseAIBot: '欢迎使用AI百宝箱',
        useCode: '手机号登录',
        useUserName: '账号登录',
        pleaseSetIphone: '请输入香港手机号（无需 852 前缀）',
        pleaseSetCode: '请输入验证码',
        getCode: '获取验证码',
        noAccount: '没有账号，立即',
        register: '注册',
        pleaseSetPassword: '请输入密码',
        login: '登录',
        pleaseAgreeXieYi: '请选择同意协议',
        alsoRead: '已阅读并同意',
        and: '与',
        userAgreement: '用户协议',
        privacyPolicy: '隐私政策',
        forgetPassWord: '忘记密码',
        resetPassWord: '重置密碼',
        pleaseSetPassWord: '请输入密码',
        againPleaseSetPassWord: '再次输入密码',
        noResetPassWord: '无需重置密码,立即',
        nowLogin: '登录',
        confirm: '确认',
        firstTimeLogin: '首次登录设置密码',
        pleaseEnterMessage: '请完成安全验证 ',
        pleaseSliderRight: '向右滑动完成验证',
        messageFail:'验证失败',
        messageSuccess:'验证成功',
        jiekouFiale: '接口验证失败数过多，请稍后再试',

    },
    // 我的资产
    userInfoMesssage:{
        tipsleft:'文件最短保存',
        tipsRighr:'小时，请及时下载'

    },
    // 网站首页
    homePage: {
        slogan1: '体验全新AI科技工具',//体验全新AI科技工具
        slogan2: '释放AI创作灵感，激发无限创意可能',//释放AI创作灵感，激发无限创意可能
        slogan3: '立即体验',//立即体验
        ALTreasureChest: 'AI百宝箱',//AI百宝箱
        greetings: '助你所想即所得',//助你所想即所得
        descrWords: '智能解析所想，一键生成佳作',//智能解析所想，一键生成佳作
        inspirationPictures: '灵感图片',//灵感图片
        specialEffectsVideo: '特效视频',//特效视频
        intelligentDialogue: '智能对话',//智能对话
        AIPPT: 'Al PPT',//Al PPT
        digitalHuman: '数字人',//数字人
        explore: '探索',//探索
        quickLogin: '快速登录',//快速登录
        myCount: '我的账户',
        myAssets: '我的资产',
        loGout: '退出登录',
        totalPoInTs: '总AI豆',
        totalEarned: '累计获得',
        totalSpent: '累计消耗',
        AIPoInTsNotEnough: 'AI豆不够？充值增加更多',
        Recharge: '充值',
        earnedAIPoints: '获得AI豆',
        spent: '消耗',
        earn: '获得',
        Date: '日期',
        MobileNumber: '手机号',
        tools:'工具',
        Source: '来源',
        spentAIPoints: '消耗AI豆',
        allToTalPoints: '总AI豆',
        onlyThirtyMessage: '仅展示近60天内的记录，暂无记录',
        sureDel: '删除资产',
        delInfo: '删除后无法恢复，确定删除？',
        all: '全部',
        Images: '图片',
        Videos: "视频",
        footer:'© 2025 中国移动香港有限公司版权所有',//© 2025 中国移动香港有限公司版权所有
        nothing:'暂无资产',//暂无资产
    },
    //支付页
    Payment: {
        headline: '通过充值获得更多AI豆',//通过充值获得更多AI豆
        subheading: '温馨提醒：AI豆不可转赠或提现，不支持退换货或反向兑换提现',//温馨提醒：AI豆不可转赠或提现，不支持退换货或反向兑换提现
        canGenerate: '可生成',//可生成
        inspirationPictures: '张灵感图片',//张灵感图片
        specialEffectsVideo: '个特效视频',//个特效视频
        intelligentDialogue: '字智能对话',//字智能对话
        AIPPT: '个AI PPT',//个AI PPT
        digitalHuman: '个数字人视频',//个数字人视频
        pay: '支付',//支付
    },
    //支付结果查询页
    RechargeInquiry: {
        topUpSuccessful: '充值成功',//充值成功
        topUpFailed: '充值失败',//充值失败
    },
    //AI对话
    AIDialog:{
        nowToalking:'最近对话',
        welcome:'欢迎使用',
        intelligentDialogue:'智能对话',// 智能对话
        startConversation:'开启新对话',// 开启新对话
        helpTips:'需要帮助？尽管提问',// 需要帮助？尽管提问
        pleaseEnterMessage:'请输入消息',// 请输入消息
        deepThinking:'深度思考',// 深度思考
        newConversation:'新对话',// 新对话
        switchModel:'切换模型',//切换模型
        Rename:'重命名',//重命名
        delete:'删除',//删除
    },
    // 视频特效模板
    effectsTemplate:{
        selectTemplate:'选择特效模版',
        clickReplace:'点击替换图片',
        UploadImage:'上传图片',
        texiao:"创意特效",
        WelcomeUse:'欢迎使用',
        EnhanceEffects:'特效增强',
        CreativeRender:'创意渲染',
        all:'全部',//全部
        fun:'趣味',//趣味
        transform:'变身',//变身
        creativity:'创意',//创意
        doll:'变身玩偶',// 变身玩偶
        pig:'召唤坐骑 - 猪',// 召唤坐骑 - 猪
        tiger:'召唤坐骑 - 老虎',// 召唤坐骑 - 老虎
        dragon:'召唤坐骑 - 龙',// 召唤坐骑 - 龙
        ikebana:'万物生花 ',// 万物生花
        hug:'拥抱',// 拥抱
        embraceLove:'爱的拥抱',// 爱的拥抱
        manyWomen:'美女环绕',// 美女环绕
        manyHandsome:'帅哥环绕',// 帅哥环绕
        baby:'天赐宝宝',// 天赐宝宝
        emo:'emoji小人变身',// emoji小人变身
        dreamyDoll:'梦幻娃娃变身',// 梦幻娃娃变身
        babyCamera:'娃娃照相机',// 娃娃照相机
        worldWind:'我的世界风',// 我的世界风
        crystalBall:'装进水晶球',// 装进水晶球
        catStarPeople:'猫星人的守护',// 猫星人的守护
        angelFigurine:'天使手办变身',// 天使手办变身
        felt:'毛毡钥匙扣变身',// 毛毡钥匙扣变身
        acrylic:'亚克力挂饰变身',// 亚克力挂饰变身
        instantCamera:'拍立得风',// 拍立得风
        collectibleToy:'潮玩手办变身',// 潮玩手办变身
        tips01:'第一个区域点击选择模版，第二个区域点击上传图片',
        uploadCheck:'请上传 JPG 或 PNG 图片，建议小于 5MB。'

    },

}
